var render = function render(_c,_vm){return _c('div',{staticClass:"one-cms-text-editor",domProps:{"innerHTML":_vm._s(_vm.props.html)}})
}
var staticRenderFns = []

export { render, staticRenderFns }